import EventBus from "@/eventBus";

export function show({ text, type }) {
  EventBus.$emit("showNotice", {
    text,
    type,
  });
}
